import React from 'react';
import '../css/reports.css'
import { FaSearch } from "react-icons/fa";

const SearchBar = ({data, setData}) => {

    const filterData = (e) => {
        const input = e.target.value;
        const filteredData = data.filter(item =>
            Object.values(item).some(value =>
              value.toLowerCase().includes(input.toLowerCase())
            )
        );
        setData(filteredData);
    }
    

    return (
        <div className='search-bar-container'>
            <FaSearch id="search-icon" />
            <input 
                type="text" 
                className="search-bar" 
                id="datatable-search-input" 
                placeholder='Buscar'
                onChange={filterData}
            />
        </div>
    );
}

export default SearchBar;
